#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"
#import "~/graphql/fragments/entryLink.graphql"
#import "~/graphql/fragments/pageContent/postCardsContent.graphql"

fragment homePageContent on home_Entry {
    title
    heroLinks: entryLinks {
        ... on entryLinks_links_BlockType {
            link: entryLink {
                ... entryLink
            }
        }
    }
    heroSlider: selectPosts {
        ... postCardsContent
    }
    heroIntro: richTextMinimal
    heroLinks2: entryLinks3 {
        ... on entryLinks3_links_BlockType {
            link: entryLink {
                ... entryLink
            }
        }
    }
    seo {
        ... socialFragment
    }
    flexibleSections {
        ... flexibleSections
    }
    showNewsletterSubscribe
}
